var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26930",
    "data-name": "Group 26930",
    transform: "translate(-249 -136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6374",
    "data-name": "Rectangle 6374",
    transform: "translate(249 136)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_115",
    "data-name": "Union 115",
    d: "M-48.387,33.173-51.25,30.31l-2.864,2.863a1.092,1.092,0,0,1-.779.323,1.092,1.092,0,0,1-.779-.323A1.1,1.1,0,0,1-56,32.394a1.1,1.1,0,0,1,.323-.779l2.864-2.864-2.861-2.86a1.1,1.1,0,0,1-.248-1.2A1.1,1.1,0,0,1-54.9,24a1.106,1.106,0,0,1,.786.329l2.861,2.861,2.859-2.859A1.1,1.1,0,0,1-47.627,24h.026a1.1,1.1,0,0,1,1.018.679,1.1,1.1,0,0,1-.248,1.212l-2.86,2.859,2.864,2.864a1.092,1.092,0,0,1,.323.779,1.092,1.092,0,0,1-.323.779,1.092,1.092,0,0,1-.779.323A1.1,1.1,0,0,1-48.387,33.173Z",
    transform: "translate(308.249 115.252)",
    fill: "#f02833"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.361aa78eef7304155adeb89cde1f632f.svg";
export { ForwardRef as ReactComponent };